export const defaultAttributeOverridesObject = {
  name: [],
  address: [],
  gender: [],
  birthDate: [],
  telecom: [],
  identifier: [],
  coverageIMDM: [],
  multipleBirth: []
};

export const handleMultipleAttributeOverride = (
  detailsMap,
  attribute,
  overrides,
  setOverrides
) => {
  if (detailsMap["Mark as"] && detailsMap["Mark as"] === "No Change") {
    // if the user initially chooses an action, then switches back to "No Change", we need to remove that item from the list
    setOverrides({
      ...overrides,
      [attribute]: [
        ...overrides[attribute].filter(item => item.id !== detailsMap.id)
      ]
    });
  } else {
    // this will remove any previous action selections for that item and add the latest action selection
    setOverrides({
      ...overrides,
      [attribute]: [
        ...overrides[attribute].filter(item => item.id !== detailsMap.id),
        detailsMap
      ]
    });
  }
};

export const handleMultipleAttributeOverrideSingleValued = (
  detailsMap,
  attribute,
  overrides,
  setOverrides
) => {
  if (detailsMap["Mark as"] && detailsMap["Mark as"] === "No Change") {
    // if the user initially chooses an action, then switches back to "No Change", we need to remove that item from the list
    setOverrides({ ...overrides, [attribute]: [] });
  } else {
    // this will remove any previous action selections for that item and add the latest action selection
    setOverrides({
      ...overrides,
      [attribute]: [...overrides[attribute], detailsMap]
    });
  }
};
